(function () {
  function initMorganicsCart() {
  if (window.MorganicsCart && window.MorganicsCart.__initialized) return;

  var drawer = document.querySelector('[data-cart-drawer]');
  var backdrop = document.querySelector('[data-cart-backdrop]');
  var body = document.querySelector('[data-cart-drawer-body]');
  var subtotalNodes = document.querySelectorAll('[data-cart-subtotal]');
  var countNodes = document.querySelectorAll('[data-cart-count]');
  var checkoutButtons = document.querySelectorAll('[data-cart-checkout]');
  var paymentProofStore = new WeakMap();
  var paymentProofErrorStore = new WeakMap();
  var COD_LIMIT_CENTS = 450000;
  var PAYMENT_PROOF_MAX_BYTES = 2000000;
  var currentCartState = null;

  if (!drawer || !body) return;

  // ─────────────────────────────────────────────────────────────────────────
  // STEP NAVIGATION
  // ─────────────────────────────────────────────────────────────────────────

  var currentStep = 1;

  function goToStep(n) {
    currentStep = n;

    // Show / hide step panels
    drawer.querySelectorAll('[data-cart-step]').forEach(function (panel) {
      var panelStep = Number(panel.dataset.cartStep);
      panel.hidden = panelStep !== n;
    });

    // Show / hide footer action bars
    drawer.querySelectorAll('[data-step-actions]').forEach(function (bar) {
      var barStep = Number(bar.dataset.stepActions);
      bar.hidden = barStep !== n;
    });

    // Update step indicator dots
    drawer.querySelectorAll('[data-step-dot]').forEach(function (dot) {
      var dotStep = Number(dot.dataset.stepDot);
      dot.classList.toggle('active', dotStep === n);
      dot.classList.toggle('done', dotStep < n);
    });

    // When entering step 3, sync the selected payment method from step 2 chooser
    if (n === 3) {
      syncChooserToDetails();
    }
  }

  /**
   * Read the selected radio from [data-payment-chooser] (step 2)
   * and activate the matching hidden radio in the [data-payment-panel] (step 3)
   * so all existing payment validation logic continues to work unchanged.
   */
  function syncChooserToDetails() {
    var chooser = drawer.querySelector('[data-payment-chooser]');
    var panel   = drawer.querySelector('[data-payment-panel]');
    if (!chooser || !panel) return;

    var selectedInput = chooser.querySelector('[data-chooser-method]:checked');
    var value    = selectedInput ? selectedInput.value : 'Cash on Delivery';
    var kind     = selectedInput ? selectedInput.dataset.paymentKind : 'cod';
    var provider = selectedInput ? (selectedInput.dataset.paymentProvider || '') : '';

    // Tick the matching hidden radio in the details panel
    panel.querySelectorAll('[data-payment-method]').forEach(function (radio) {
      radio.checked = (radio.value === value);
    });

    // Update the confirm header label
    var confirmLabel = panel.querySelector('[data-payment-confirm-label]');
    if (confirmLabel) confirmLabel.textContent = value;

    // Show / hide the COD confirm block vs online details
    var codConfirm = panel.querySelector('[data-payment-detail="cod-confirm"]');
    if (codConfirm) codConfirm.hidden = (kind !== 'cod');

    // Run the existing panel update so QR/proof visibility updates correctly
    updatePaymentPanel(panel, false);
  }

  // Re-sync whenever the chooser selection changes while on step 2
  function onChooserChange(event) {
    var method = event.target.closest('[data-chooser-method]');
    if (!method) return;
    // If user is on step 2, keep step 3 in sync proactively
    var chooser = method.closest('[data-payment-chooser]');
    if (chooser) {
      // Nothing to do yet — sync happens when user navigates to step 3
    }
  }

  // ─────────────────────────────────────────────────────────────────────────
  // IMAGE FALLBACKS
  // ─────────────────────────────────────────────────────────────────────────

  function getImageFallbacks() {
    var fallbackNode = document.getElementById('MorganicsCartImageFallbacks');
    if (!fallbackNode) return {};

    try {
      return JSON.parse(fallbackNode.textContent || '{}') || {};
    } catch (error) {
      return {};
    }
  }

  var imageFallbacks = getImageFallbacks();

  // ─────────────────────────────────────────────────────────────────────────
  // MONEY + HTML UTILS
  // ─────────────────────────────────────────────────────────────────────────

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }

    return new Intl.NumberFormat('en-PK', {
      style: 'currency',
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'PKR',
      maximumFractionDigits: 0
    }).format((cents || 0) / 100);
  }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  // ─────────────────────────────────────────────────────────────────────────
  // PAYMENT VALIDATION (unchanged)
  // ─────────────────────────────────────────────────────────────────────────

  function selectedPayment(panel) {
    return panel && panel.querySelector('[data-payment-method]:checked');
  }

  function paymentProviderName(method) {
    return method ? method.value : 'Cash on Delivery';
  }

  function paymentProviderCode(method) {
    return method && method.dataset.paymentProvider ? method.dataset.paymentProvider : 'cod';
  }

  function paymentKind(method) {
    return method && method.dataset.paymentKind ? method.dataset.paymentKind : 'cod';
  }

  function paymentProof(panel) {
    return paymentProofStore.get(panel) || null;
  }

  function paymentReference(panel) {
    var input = panel && panel.querySelector('[data-payment-reference]');
    return input ? String(input.value || '').trim() : '';
  }

  function setPaymentError(panel, message) {
    var node = panel && panel.querySelector('[data-payment-error]');
    if (!node) return;
    node.textContent = message || '';
    node.hidden = !message;
  }

  function cartTotalForPanel(panel) {
    return Number(panel && panel.dataset.cartTotal ? panel.dataset.cartTotal : 0) || 0;
  }

  function paymentValidationMessage(panel, showSoftMessage) {
    var method = selectedPayment(panel);
    var isOnline = method && method.dataset.paymentKind === 'online';
    var isCod = method && method.dataset.paymentKind === 'cod';

    if (isCod && cartTotalForPanel(panel) > COD_LIMIT_CENTS) {
      return 'Cash on Delivery is unavailable for orders above Rs 4,500.';
    }

    if (!isOnline) return '';
    if (paymentProofErrorStore.has(panel)) return paymentProofErrorStore.get(panel);
    if (!paymentProof(panel)) return showSoftMessage ? 'Please upload payment receipt before checkout.' : '';
    return '';
  }

  function isPaymentReady(panel) {
    var method = selectedPayment(panel);
    if (!method) return false;
    if (method.dataset.paymentKind === 'cod') return cartTotalForPanel(panel) <= COD_LIMIT_CENTS;
    return !!paymentProof(panel);
  }

  function updatePaymentPanel(panel, showSoftMessage) {
    if (!panel) return;
    var method = selectedPayment(panel);
    var provider = method && method.dataset.paymentProvider;
    var proofFields = panel.querySelector('[data-payment-proof-fields]');
    var checkoutButton = panel.closest('form') && panel.closest('form').querySelector('[data-payment-checkout], [data-cart-checkout]');
    var isOnline = method && method.dataset.paymentKind === 'online';

    panel.querySelectorAll('[data-payment-detail]').forEach(function (detail) {
      // Skip the COD confirm block — that is managed by syncChooserToDetails
      if (detail.dataset.paymentDetail === 'cod-confirm') return;
      var visible = isOnline && detail.dataset.paymentDetail === provider;
      detail.hidden = !visible;
    });

    if (proofFields) proofFields.hidden = !isOnline;
    setPaymentError(panel, paymentValidationMessage(panel, showSoftMessage));

    if (checkoutButton) {
      checkoutButton.disabled = checkoutButton.hasAttribute('data-cart-empty') || !isPaymentReady(panel);
    }
  }

  function updatePaymentPanels(showSoftMessage) {
    document.querySelectorAll('[data-payment-panel]').forEach(function (panel) {
      updatePaymentPanel(panel, showSoftMessage);
    });
  }

  // ─────────────────────────────────────────────────────────────────────────
  // PAYMENT SELECTION SAVE
  // ─────────────────────────────────────────────────────────────────────────

  function serializeProof(panel) {
    var proof = paymentProof(panel);
    if (!proof) return {};
    return {
      name: proof.name,
      type: proof.type,
      size: proof.size,
      uploadedAt: proof.uploadedAt,
      dataUrl: proof.dataUrl || ''
    };
  }

  function persistPaymentChoice(method) {
    if (!method) return Promise.resolve();

    var methodName = paymentProviderName(method);
    var kind = paymentKind(method);
    var provider = paymentProviderCode(method);

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          'Selected Payment Method': methodName,
          'Payment Gateway Selected In Cart': methodName,
          'Shopify Checkout Gateway To Select': methodName,
          'Payment Provider': provider,
          'Payment Type': kind
        }
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('Payment method was not saved to Shopify cart.');
      return response.json();
    });
  }

  function savePaymentSelection(panel) {
    var method = selectedPayment(panel);
    var proof = serializeProof(panel);
    var reference = paymentReference(panel);
    var methodName = paymentProviderName(method);
    var kind = paymentKind(method);
    var provider = paymentProviderCode(method);
    var isOnline = kind === 'online';
    var paymentStatus = isOnline ? 'Pending Verification' : 'COD Pending';
    var receiptStatus = isOnline && proof.name ? 'Receipt provided' : (isOnline ? 'Receipt missing' : 'Not required for COD');
    var savedAt = new Date().toISOString();
    var verificationSummary = [
      'Method: ' + methodName,
      'Provider: ' + provider,
      'Status: ' + paymentStatus,
      'Reference: ' + (reference || 'Not provided'),
      'Receipt: ' + (proof.name || receiptStatus)
    ].join(' | ');
    var orderNote = [
      'Morganics cart payment selection',
      verificationSummary,
      isOnline ? 'Customer must select the matching manual payment method in Shopify checkout.' : 'Customer selected Cash on Delivery before checkout.'
    ].join('\n');
    var attributes = {
      'Selected Payment Method': methodName,
      'Payment Gateway Selected In Cart': methodName,
      'Shopify Checkout Gateway To Select': methodName,
      'Payment Provider': provider,
      'Payment Type': kind,
      'Transaction Reference': reference,
      'Payment Proof Upload': proof.name || '',
      'Payment Proof File Type': proof.type || '',
      'Payment Proof File Size': proof.size ? String(proof.size) : '',
      'Payment Proof Captured At': proof.uploadedAt || '',
      'Payment Proof Storage': proof.name ? 'Filename saved with order; image upload requires a Shopify app or upload endpoint.' : '',
      'Payment Status': paymentStatus,
      'Payment Receipt Status': receiptStatus,
      'Admin Verification': isOnline ? 'Required before dispatch' : 'Confirm cash collection on delivery',
      'Courier Payment Instruction': isOnline ? 'Prepaid - verify receipt before dispatch' : 'Collect cash on delivery',
      'PostEx Payment Status': paymentStatus,
      'Payment Record Saved At': savedAt,
      'Payment Verification Summary': verificationSummary
    };

    try {
      window.localStorage.setItem('morganics_payment_selection', JSON.stringify({
        paymentMethod: methodName,
        paymentKind: kind,
        paymentProvider: provider,
        transactionReference: reference,
        proof: proof,
        paymentStatus: paymentStatus,
        receiptStatus: receiptStatus,
        savedAt: savedAt
      }));
    } catch (error) {}

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        note: orderNote,
        attributes: attributes
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('Payment details were not saved to Shopify cart.');
      return response.json();
    });
  }

  function copyText(value, button) {
    if (!value) return;
    var done = function () {
      if (!button) return;
      var original = button.dataset.copyOriginal || button.textContent;
      button.dataset.copyOriginal = original;
      button.textContent = 'Copied';
      button.classList.add('is-copied');
      window.setTimeout(function () {
        button.textContent = original;
        button.classList.remove('is-copied');
      }, 1400);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(value).then(done).catch(function () {});
      return;
    }

    var input = document.createElement('textarea');
    input.value = value;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.top = '-999px';
    document.body.appendChild(input);
    input.select();
    try {
      document.execCommand('copy');
      done();
    } catch (error) {}
    document.body.removeChild(input);
  }

  // ─────────────────────────────────────────────────────────────────────────
  // IMAGE HELPERS (unchanged)
  // ─────────────────────────────────────────────────────────────────────────

  function normalizeImageUrl(image) {
    if (!image) return '';
    if (typeof image === 'string') return image;
    if (typeof image === 'object') return image.url || image.src || '';
    return '';
  }

  function productHandle(item) {
    if (item.handle) return item.handle;
    if (item.product_handle) return item.product_handle;

    var url = item.url || '';
    var match = url.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function imageForLineItem(item) {
    var image = normalizeImageUrl(item.image || item.featured_image);
    var handle = productHandle(item);

    if (image) return image;
    if (handle && imageFallbacks[handle]) return imageFallbacks[handle];

    return imageFallbacks['ajwa-dates'] || '';
  }

  // ─────────────────────────────────────────────────────────────────────────
  // CART OPEN / CLOSE (unchanged + reset to step 1 on open)
  // ─────────────────────────────────────────────────────────────────────────

  function openCart() {
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    if (backdrop) {
      backdrop.classList.add('open');
      backdrop.setAttribute('aria-hidden', 'false');
    }
    document.body.classList.add('cart-open');
    goToStep(1); // always start from step 1
  }

  function closeCart() {
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    if (backdrop) {
      backdrop.classList.remove('open');
      backdrop.setAttribute('aria-hidden', 'true');
    }
    document.body.classList.remove('cart-open');
  }

  // ─────────────────────────────────────────────────────────────────────────
  // RENDER (unchanged + reset to step 1 on re-render)
  // ─────────────────────────────────────────────────────────────────────────

  function renderEmptyCart() {
    return [
      '<div class="empty-cart">',
      '<h3>Your cart is empty.</h3>',
      '<p>Start with pantry essentials, dry fruits, spices, or daily rituals.</p>',
      '<a class="btn primary" href="/collections/all">Shop Products</a>',
      '</div>'
    ].join('');
  }

  function renderPowderBadge(item) {
    var props = item.properties || {};
    var isPowdered = props['Powder Form'] === 'Yes';
    if (!isPowdered) return '';
    return '<span class="mrg-powder-badge" aria-label="Powder form selected">' +
           '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"></polyline></svg>' +
           ' Powder Form</span>';
  }

  function renderVisibleProperties(item) {
    var props = item.properties || {};
    var keys = Object.keys(props);
    var lines = keys.filter(function (k) {
      // Skip underscore-prefixed internal keys and the Powder Form key (shown as badge)
      return k.charAt(0) !== '_' && k !== 'Powder Form';
    }).map(function (k) {
      return '<span class="cart-line-property"><b>' + escapeHtml(k) + ':</b> ' + escapeHtml(String(props[k])) + '</span>';
    });
    return lines.join('');
  }

  function injectPowderBadgeStyles() {
    if (document.getElementById('mrg-powder-badge-styles')) return;
    var style = document.createElement('style');
    style.id = 'mrg-powder-badge-styles';
    style.textContent = [
      '.mrg-powder-badge {',
      '  display: inline-flex;',
      '  align-items: center;',
      '  gap: 5px;',
      '  font-size: 11px;',
      '  font-weight: 700;',
      '  color: #173f36;',
      '  background: rgba(23,63,54,0.09);',
      '  border: 1px solid rgba(23,63,54,0.18);',
      '  border-radius: 999px;',
      '  padding: 2px 9px 2px 6px;',
      '  margin-top: 5px;',
      '  letter-spacing: 0.01em;',
      '  line-height: 1.4;',
      '  white-space: nowrap;',
      '}',
      '.mrg-powder-badge svg {',
      '  flex-shrink: 0;',
      '  color: #2d7a5c;',
      '}',
      '.cart-line-property {',
      '  display: block;',
      '  font-size: 11px;',
      '  color: rgba(23,63,54,0.6);',
      '  margin-top: 2px;',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function renderLineItem(item) {
    injectPowderBadgeStyles();
    var imageUrl = imageForLineItem(item);
    var image = imageUrl
      ? '<img src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(item.product_title) + '" width="180" height="180" loading="lazy">'
      : '';
    var variant = item.variant_title && item.variant_title !== 'Default Title'
      ? '<span class="cart-line-variant">' + escapeHtml(item.variant_title) + '</span>'
      : '';
    var discounts = item.discounts && item.discounts.length
      ? '<ul class="cart-line-discounts">' + item.discounts.map(function (discount) {
          return '<li>' + escapeHtml(discount.title) + '</li>';
        }).join('') + '</ul>'
      : '';
    var originalPrice = item.original_line_price !== item.final_line_price
      ? '<s>' + formatMoney(item.original_line_price) + '</s>'
      : '';
    var powderBadge = renderPowderBadge(item);
    var visibleProps = renderVisibleProperties(item);

    return [
      '<div class="cart-line cart-line-drawer" data-cart-line-item data-line-key="' + escapeHtml(item.key) + '">',
      '<a class="cart-line-image" href="' + escapeHtml(item.url) + '">' + image + '</a>',
      '<div class="cart-line-info">',
      '<a class="cart-line-title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>',
      variant,
      powderBadge,
      visibleProps,
      discounts,
      '<div class="qty cart-line-qty">',
      '<button type="button" data-cart-qty data-line-key="' + escapeHtml(item.key) + '" data-quantity="' + (item.quantity - 1) + '" aria-label="Decrease quantity">−</button>',
      '<span data-cart-line-quantity>' + item.quantity + '</span>',
      '<button type="button" data-cart-qty data-line-key="' + escapeHtml(item.key) + '" data-quantity="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>',
      '</div>',
      '</div>',
      '<div class="cart-line-price">',
      originalPrice,
      '<strong>' + formatMoney(item.final_line_price) + '</strong>',
      '<button class="cart-del" type="button" data-cart-remove data-line-key="' + escapeHtml(item.key) + '">Remove</button>',
      '</div>',
      '</div>'
    ].join('');
  }

  function updateCount(count) {
    countNodes.forEach(function (node) {
      node.textContent = count;
    });

    // Update step 1 "Continue to Payment" disabled state
    drawer.querySelectorAll('[data-step-next-requires-items]').forEach(function (btn) {
      btn.disabled = count === 0;
    });

    checkoutButtons.forEach(function (button) {
      button.toggleAttribute('data-cart-empty', count === 0);
      button.disabled = count === 0;
    });
    updatePaymentPanels(false);
  }

  function renderCart(cart) {
    currentCartState = cart;
    var visibleItems = cart.item_count ? cart.items : [];

    body.innerHTML = visibleItems.length ? visibleItems.map(renderLineItem).join('') : renderEmptyCart();
    subtotalNodes.forEach(function (node) {
      node.textContent = formatMoney(cart.total_price);
    });
    document.querySelectorAll('[data-payment-panel]').forEach(function (panel) {
      panel.dataset.cartTotal = cart.total_price;
    });
    document.querySelectorAll('[data-payment-chooser]').forEach(function (chooser) {
      chooser.dataset.cartTotal = cart.total_price;
    });

    var visibleCount = visibleItems.reduce(function (total, item) {
      return total + item.quantity;
    }, 0);
    updateCount(visibleCount);

    // Reset to step 1 whenever cart data refreshes
    goToStep(1);
  }

  function refreshCart(shouldOpen) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        renderCart(cart);
        if (shouldOpen) openCart();
        return cart;
      });
  }

  function changeCart(key, quantity) {
    body.classList.add('is-loading');

    var qty = Math.max(0, Number(quantity) || 0);
    var updates = {};
    updates[key] = qty;

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        renderCart(cart);
      })
      .finally(function () {
        body.classList.remove('is-loading');
      });
  }

  // ─────────────────────────────────────────────────────────────────────────
  // EVENT DELEGATION
  // ─────────────────────────────────────────────────────────────────────────

  document.addEventListener('click', function (event) {
    var openButton      = event.target.closest('[data-cart-open]');
    var closeButton     = event.target.closest('[data-cart-close]');
    var quantityButton  = event.target.closest('[data-cart-qty]');
    var removeButton    = event.target.closest('[data-cart-remove]');
    var pageQtyButton   = event.target.closest('[data-cart-page-qty]');
    var stepNextButton  = event.target.closest('[data-step-next]');
    var stepBackButton  = event.target.closest('[data-step-back]');
    var paymentCard     = event.target.closest('.morganics-payment-method');
    var copyButton      = event.target.closest('[data-copy-value]');

    if (copyButton) {
      event.preventDefault();
      copyText(copyButton.dataset.copyValue, copyButton);
    }

    if (paymentCard && !paymentCard.classList.contains('is-disabled')) {
      var paymentInput = paymentCard.querySelector('[data-payment-method]');
      if (paymentInput && !paymentInput.disabled) {
        paymentInput.checked = true;
        updatePaymentPanel(paymentInput.closest('[data-payment-panel]'), true);
        persistPaymentChoice(paymentInput).catch(function () {});
      }
    }

    if (openButton) {
      event.preventDefault();
      refreshCart(true);
    }

    if (closeButton && !closeButton.href) {
      event.preventDefault();
      closeCart();
    }

    if (quantityButton) {
      event.preventDefault();
      changeCart(quantityButton.dataset.lineKey, quantityButton.dataset.quantity);
    }

    if (removeButton) {
      event.preventDefault();
      changeCart(removeButton.dataset.lineKey, 0);
    }

    if (pageQtyButton) {
      var qtyWrap = pageQtyButton.closest('.cart-line-qty');
      var input = qtyWrap && qtyWrap.querySelector('.cart-qty-input');
      var nextValue = input ? Math.max(0, Number(input.value || 0) + Number(pageQtyButton.dataset.step || 0)) : 0;
      if (input) {
        input.value = nextValue;
        var form = input.closest('form');
        if (form) form.submit();
      }
    }

    // ── Step navigation ──────────────────────────────────────────────────
    if (stepNextButton) {
      event.preventDefault();
      var nextStep = Number(stepNextButton.dataset.stepNext);
      if (nextStep) goToStep(nextStep);
    }

    if (stepBackButton) {
      event.preventDefault();
      var backStep = Number(stepBackButton.dataset.stepBack);
      if (backStep) goToStep(backStep);
    }
  });

  document.addEventListener('change', function (event) {
    var method      = event.target.closest('[data-payment-method]');
    var proofInput  = event.target.closest('[data-payment-proof]');
    var chooser     = event.target.closest('[data-chooser-method]');
    var qtyInput    = event.target.closest('.cart-qty-input');

    if (qtyInput) {
      var form = qtyInput.closest('form');
      if (form) form.submit();
    }

    if (method) {
      updatePaymentPanel(method.closest('[data-payment-panel]'), true);
      persistPaymentChoice(method).catch(function () {});
    }

    if (chooser) {
      onChooserChange(event);
      persistPaymentChoice(chooser).catch(function () {});
    }

    if (proofInput) {
      var panel = proofInput.closest('[data-payment-panel]');
      var file = proofInput.files && proofInput.files[0];
      var label = panel && panel.querySelector('[data-payment-proof-name]');

      if (!file) {
        paymentProofStore.delete(panel);
        paymentProofErrorStore.delete(panel);
        if (label) label.textContent = 'No receipt selected';
        updatePaymentPanel(panel, true);
        return;
      }

      if (file.size > PAYMENT_PROOF_MAX_BYTES) {
        paymentProofStore.delete(panel);
        paymentProofErrorStore.set(panel, 'Receipt file must be 2 MB or smaller.');
        proofInput.value = '';
        if (label) label.textContent = 'File is larger than 2 MB';
        updatePaymentPanel(panel, true);
        return;
      }

      var proofMeta = {
        name: file.name,
        type: file.type || 'file',
        size: file.size,
        uploadedAt: new Date().toISOString()
      };

      paymentProofErrorStore.delete(panel);
      if (label) label.textContent = file.name;
      paymentProofStore.set(panel, proofMeta);
      updatePaymentPanel(panel, true);

      if (window.FileReader) {
        var reader = new FileReader();
        reader.onload = function () {
          proofMeta.dataUrl = reader.result;
          paymentProofStore.set(panel, proofMeta);
        };
        reader.readAsDataURL(file);
      }
    }

  });

  document.addEventListener('input', function (event) {
    var referenceInput = event.target.closest('[data-payment-reference]');
    if (referenceInput) updatePaymentPanel(referenceInput.closest('[data-payment-panel]'), true);
  });

  document.addEventListener('submit', function (event) {
    var checkoutForm = event.target.closest('[data-payment-checkout-form]');
    if (checkoutForm) {
      var panel = checkoutForm.querySelector('[data-payment-panel]');
      var checkoutButton = checkoutForm.querySelector('[data-payment-checkout], [data-cart-checkout]');

      event.preventDefault();
      updatePaymentPanel(panel, true);

      if (!isPaymentReady(panel)) return;
      if (checkoutButton) checkoutButton.disabled = true;

      savePaymentSelection(panel)
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function () {
          if (checkoutButton) checkoutButton.disabled = false;
          setPaymentError(panel, 'Payment details could not be saved. Please try checkout again.');
        });
      return;
    }

    var form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    event.preventDefault();
    var submitButton = form.querySelector('[type="submit"]');
    if (submitButton) submitButton.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart add failed');
        return response.json();
      })
      .then(function () {
        if (submitButton) submitButton.classList.add('is-success');
        return refreshCart(true);
      })
      .catch(function () {
        form.submit();
      })
      .finally(function () {
        if (submitButton) submitButton.disabled = false;
        if (submitButton) {
          window.setTimeout(function () { submitButton.classList.remove('is-success'); }, 900);
        }
      });
  });

  document.addEventListener('cart:refresh', function () {
    refreshCart(false);
  });

  document.addEventListener('cart:open', function () {
    refreshCart(true);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeCart();
  });

  // ─────────────────────────────────────────────────────────────────────────
  // INIT
  // ─────────────────────────────────────────────────────────────────────────

  updatePaymentPanels(false);
  goToStep(1); // ensure correct initial state

  window.MorganicsCart = {
    __initialized: true,
    open: openCart,
    close: closeCart,
    refresh: refreshCart,
    goToStep: goToStep
  };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMorganicsCart, { once: true });
  } else {
    initMorganicsCart();
  }
})();
